<template>
  <div>
    <card-incidents-table />
  </div>
</template>
<script>
/* 
  Class: Incidents
  Description: This class representing a main entry point for incidents.
*/

/* Imports */
import CardIncidentsTable from '@/components/Cards/Incidents/CardIncidentsTable.vue';
/* /Imports/ */

export default {
  /* 
    Define different meta options. 
  */
  metaInfo() {
    return {
      title: this.$appName,
      titleTemplate: "%s | " + this.$route.name,
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    CardIncidentsTable
  }
}
</script>